import React, { useState } from "react";
import { Select, Space } from "antd";

function AovSelectOption({ gender, setGender, graphType, setGraphType, orderType, setOrderType }) {
  return (
    <div className="">
      <Space wrap>
        <Select
          value={gender}
          placeholder="Please select Gender"
          style={{
            width: 180,
          }}
          allowClear
          onChange={(value) => {
            setGender(value);
          }}
          onClear={() => {
            setGender(null);
          }}
          options={[
            {
              value: "male",
              label: "Male",
            },
            {
              value: "female",
              label: "Female",
            },
          ]}
        />
        <Select
          value={orderType}
          placeholder="Please select Customer Type"
          style={{
            width: 180,
          }}
          allowClear
          onChange={(value) => {
            setOrderType(value);
          }}
          onClear={() => {
            setOrderType(null);
          }}
          options={[
            {
              value: "New",
              label: "New",
            },
            {
              value: "Repeat",
              label: "Repeat",
            },
          ]}
        />
        <Select
          placeholder="Please select Graph Type"
          style={{
            width: 180,
          }}
          value={graphType}
          onChange={(value) => setGraphType(value)}
          options={[
            {
              value: "aov",
              label: "Average Order Value",
            },
            {
              value: "total_order_value",
              label: "Total Order Value",
            },
            {
              value: "total_order_count",
              label: "Total Order Count",
            },
          ]}
        />
      </Space>
    </div>
  );
}

export default AovSelectOption;

